export default "__VITE_ASSET__Cy37xyjk__"